import { SyntheticEvent, useState } from 'react'

/** The select's menu (portalled into a popover). */
const isInsideMenu = (target: EventTarget): boolean =>
  target instanceof Element && target.closest('.MuiPopover-root') !== null

/**
 * Open state for a tooltip on a select. The tooltip shows only while the
 * menu is closed: open, it would cover the menu's first entry (the select
 * keeps focus). A hover that reaches the select while its menu is open --
 * the pointer moves behind the menu -- is ignored, and closing the menu
 * hides the tooltip: the pointer left while the menu covered the select, so
 * no "leave" would ever close it. Hovers over the menu itself are ignored
 * too: the menu is portalled but bubbles its events to the tooltip, whose
 * delayed open would otherwise fire right after an entry was picked.
 */
const useSelectTooltip = () => {
  const [tooltipOpen, setTooltipOpen] = useState(false)
  const [menuOpen, setMenuOpen] = useState(false)

  return {
    tooltipProps: {
      open: tooltipOpen && !menuOpen,
      onOpen: (event: SyntheticEvent) => {
        if (menuOpen || isInsideMenu(event.target)) return
        setTooltipOpen(true)
      },
      onClose: () => setTooltipOpen(false),
    },
    selectProps: {
      open: menuOpen,
      onOpen: () => {
        setTooltipOpen(false)
        setMenuOpen(true)
      },
      onClose: () => {
        setTooltipOpen(false)
        setMenuOpen(false)
      },
    },
  }
}

export default useSelectTooltip
